import React from "react";
import { Field } from "react-final-form";
import PropTypes from "prop-types";
import Select from "react-select";

const SelectField = ({
                         name,
                         options,
                         label,
                         isMandatory = false,
                         isMulti = false,
                         placeholder,
                         validate,
                         value,
                         dataTest,
                         onChange,
                         disabled,
                         ...rest
                     }) => {

    const getParse = (value) => {
        if (value === null) return null;
        if (isMulti) {
            return value.map(item => item.value);
        } else {
            return value.value;
        }
    };

    const getValue = (value) => {
        if (!isMulti) {
            let item = options.find(item => item.value === value);
            if (!item) {
                let final = null;
                options.map(option => {
                    if (option.options) {
                        let _item = option.options.find((itemValue) => itemValue.value === value);
                        if (!_item) return null;
                        final = { value: _item.value, label: _item.name };
                    }
                });
                return final;
            }
            return item;
        } else {
            let array = [];
            if (Array.isArray(value)) {
                value.map(item => {
                    options.map(option => {
                        if (option.options) {
                            let _item = option.options.find((itemValue) => itemValue.value === item);
                            if (!_item) return null;
                            array.push({
                                value: _item.value, label: item.name
                            });
                        } else if (item === option.value) {
                            array.push({ value: option.value, label: option.label });
                        }
                    });
                });
            }
            return array;
        }
    };

    const errorMessage = (message) => (
        <span style={{ color: "red", marginRight: "10px" }} className={"text-sm"}>
            <i className="fa fa-arrow-up"> </i> {message}
        </span>
    );

    const renderError = (_props) => {
        if (_props.meta.error && _props.meta.touched) {
            if (!_props.input.value || _props.input.value === "") return errorMessage("Povinné pole");
        }
        return null;
    };

    return (
        <Field
            name={name}
            validate={(value) => {
                if (isMandatory) {
                    if (
                        value === null ||
                        value === undefined ||
                        value === '' // pokud chceš, můžeš odstranit, pokud prázdný string je validní
                    ) {
                        return true; // nevalidní
                    }
                }
                return false;
            }}
            render={(_props) => (
                <div className={"w-full p-1"}>
                    <div className={"form-label font-bold pb-1 pt-1"}>
                        {label && label + ": "}
                        {isMandatory ? <sup className={"text-legendyColor"}>*</sup> : ""}
                    </div>
                    <Select
                        {...rest}
                        styles={{
                            menu: (base) => ({ ...base, zIndex: 9999 }),
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                        isMulti={isMulti}
                        placeholder={placeholder || "Vyberte..."}
                        onChange={(value) => {
                            _props.input.onChange(value);
                            if (onChange) {
                                onChange(value);
                            }
                        }}
                        options={options}
                        value={_props.input.value}
                        isDisabled={disabled}
                        isClearable
                    />
                    {renderError(_props)}
                </div>
            )}
            parse={getParse}
            format={getValue}
        />
    );
};

SelectField.propTypes = {
    name: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
    label: PropTypes.string.isRequired,
    isMandatory: PropTypes.bool,
    isMulti: PropTypes.bool,
    placeholder: PropTypes.string,
    validate: PropTypes.func,
    value: PropTypes.object,
    dataTest: PropTypes.string,
    onChange: PropTypes.func,
    disabled: PropTypes.bool
};

export default SelectField;
